if (typeof Swiper === 'undefined') {
  console.error('Swiper library not loaded');
}

class UgcReviews extends HTMLElement {
  constructor() {
    super();
    this.videosSwiperInstance = null;
    this.reviewsSwiperInstance = null;
  }

  connectedCallback() {
    this.section = this.closest('.ugc-reviews');
    if (!this.section) return;

    this.initVideosSwiper();
    this.initReviewsSwiper();
    this.initVideoPlayers();
  }

  initVideosSwiper() {
    const swiperEl = this.section.querySelector('.ugc-reviews__videos-swiper');
    if (!swiperEl) return;

    const slides = swiperEl.querySelectorAll('.swiper-slide');

    this.videosSwiperInstance = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      centeredSlides: true,
      loop: true,
      loopedSlides: slides.length,
      initialSlide: Math.floor(slides.length / 2),
      navigation: {
        nextEl: this.section.querySelector('.swiper-nav__arrow--next'),
        prevEl: this.section.querySelector('.swiper-nav__arrow--prev'),
      },
      pagination: {
        el: this.section.querySelector('.swiper-nav__pagination'),
        clickable: true,
      },
      breakpoints: {
        990: {
          spaceBetween: 18,
          centeredSlides: false,
          loop: false,
          initialSlide: 0,
        }
      }
    });

    this.videosSwiperInstance.on('slideChange', () => {
      this.pauseAllVideos();
    });
  }

  initReviewsSwiper() {
    const swiperEl = this.section.querySelector('.ugc-reviews__reviews-swiper');
    if (!swiperEl) return;

    const slides = swiperEl.querySelectorAll('.swiper-slide');

    this.reviewsSwiperInstance = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 6,
      centeredSlides: true,
      loop: true,
      loopedSlides: slides.length,
      initialSlide: Math.floor(slides.length / 2),
      breakpoints: {
        990: {
          spaceBetween: 12,
          centeredSlides: false,
          loop: false,
          initialSlide: 0,
        }
      }
    });
  }

  initVideoPlayers() {
    const cards = this.section.querySelectorAll('.video-card');

    cards.forEach(card => {
      const video = card.querySelector('.video-card__video');
      const playBtn = card.querySelector('.video-card__play');
      const muteBtn = card.querySelector('.video-card__mute');

      if (!video) return;

      // Click on card area toggles play/pause
      card.addEventListener('click', (e) => {
        // Ignore clicks on mute button
        if (muteBtn && muteBtn.contains(e.target)) return;

        if (card.classList.contains('is-playing')) {
          this.pauseVideo(card, video);
        } else {
          this.playVideo(card, video);
        }
      });

      // Mute/unmute button
      if (muteBtn) {
        muteBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          if (video.muted) {
            video.muted = false;
            card.classList.add('is-unmuted');
          } else {
            video.muted = true;
            card.classList.remove('is-unmuted');
          }
        });
      }
    });
  }

  playVideo(card, video) {
    // Pause any other playing videos first
    this.pauseAllVideos();

    // Load source if not yet loaded
    if (!video.src && !video.querySelector('source[src]')) {
      const src = card.dataset.videoSrc;
      if (!src) return;
      video.src = src;
    }

    video.play().then(() => {
      card.classList.add('is-playing');
    }).catch(() => {
      // Autoplay blocked, keep showing play button
    });
  }

  pauseVideo(card, video) {
    video.pause();
    card.classList.remove('is-playing');
  }

  pauseAllVideos() {
    const cards = this.section.querySelectorAll('.video-card.is-playing');
    cards.forEach(card => {
      const video = card.querySelector('.video-card__video');
      if (video) {
        video.pause();
      }
      card.classList.remove('is-playing');
    });
  }
}

customElements.define('ugc-reviews', UgcReviews);

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.ugc-reviews');

  sections.forEach(section => {
    const customElement = document.createElement('ugc-reviews');
    section.appendChild(customElement);
  });
});
